import { defineMessages } from 'react-intl';

export const workflowsSidebarSectionMessages = defineMessages({
  scheduledRoutines: {
    defaultMessage: 'Scheduled',
    id: '+Ak3jLAXQ8',
    description:
      'Sidebar section title for the list of routines that have a schedule (used in both the Chat sidebar and the Agent Home nav)',
  },
  loading: {
    defaultMessage: 'Loading',
    id: 'Oi7qzXl1SG',
    description: 'Sidebar routines loading state',
  },
  loadError: {
    defaultMessage: 'Couldn’t load your scheduled routines',
    id: '9DL65ogZPp',
    description:
      'Sidebar compact error state shown when either the workflows or schedules query fails',
  },
  showLess: {
    defaultMessage: 'Show less',
    id: 'OsK690T7tV',
    description: 'Sidebar collapse routines list',
  },
  showMore: {
    // The =0 branch is reachable: when the focused routine is the only one past
    // the collapse cut it gets hoisted into view, leaving hiddenCount at 0
    // while the toggle still renders.
    defaultMessage:
      '{count, plural, =0 {Show more} one {Show more (#)} other {Show more (#)}}',
    id: '0ghksGVyOp',
    description: 'Sidebar expand routines list',
  },
});
